module.exports = __webpack_public_path__ + "static/media/simurator_title.f30cd344.webp";